import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { CurrencyRateModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[CurrencyRate] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[CurrencyRate] Load items success', props<{ data: PaginationAdapter<CurrencyRateModel> }>());

// item
export const loadItem = createAction('[CurrencyRate] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[CurrencyRate] Load item success', props<{ item: CurrencyRateModel }>());
